import { render, staticRenderFns } from "./SolicitudesConPolizas.vue?vue&type=template&id=58a88898"
import script from "./SolicitudesConPolizas.vue?vue&type=script&lang=js"
export * from "./SolicitudesConPolizas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports